import React from 'react'
import { usePostRequest } from '../hooks/request'
import { CLIENT_LIST, ORDER_LIST } from '../urls'
import ClientForm from './ClientForm'

export default function ClientCreate({
    onCancel,
    active,
    reload,
}) {
    const client = usePostRequest({ url: CLIENT_LIST })
    const orders = usePostRequest({ url: ORDER_LIST })

    async function onSubmit(data, action) {
        const {
            success,
            response,
        } = await client.request({ data })

        if (active && response) {
            await orders.request({
                data: {
                    client: response.id,
                    items: [],
                },
            })
        }
        if (success) {
            onCancel()
            action.resetForm()
            if (!active) {
                orders.request()
            } else {
                reload.request()
            }
        }
    }

    return (
        <div>
            <h1 className="title has-text-centered is-capitalized"><b>добавить новый клиента</b></h1>
            <ClientForm
                onCancel={onCancel}
                onSubmit={onSubmit} />
        </div>

    )
}
